var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSicon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 37,
    viewBox: "0 0 39 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3491 0.90625C8.85126 0.90625 0.311096 9.00201 0.311096 18.9535C0.311096 28.9051 8.85126 37.0008 19.3491 37.0008C29.8469 37.0008 38.3871 28.9051 38.3871 18.9535C38.3871 9.00201 29.8469 0.90625 19.3491 0.90625ZM9.19538 14.4417C9.19538 13.1124 10.3311 12.0358 11.7334 12.0358C13.1356 12.0358 14.2713 13.1124 14.2713 14.4417C14.2713 15.771 13.1356 16.8476 11.7334 16.8476C10.3311 16.8476 9.19538 15.771 9.19538 14.4417ZM26.8846 25.8713H11.654C11.2163 25.8713 10.8606 25.5341 10.8606 25.1192C10.8606 24.7042 11.2163 24.3671 11.654 24.3671H26.8846C27.3223 24.3671 27.678 24.7042 27.678 25.1192C27.678 25.5341 27.3223 25.8713 26.8846 25.8713ZM26.9639 16.8476C25.5617 16.8476 24.4259 15.771 24.4259 14.4417C24.4259 13.1124 25.5617 12.0358 26.9639 12.0358C28.3662 12.0358 29.5019 13.1124 29.5019 14.4417C29.5019 15.771 28.3662 16.8476 26.9639 16.8476Z",
    fill: "#F7BD1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6516 16.6847C13.9585 16.2044 14.6072 14.8107 14.1006 13.5718C13.5939 12.3329 12.1237 11.7179 10.8168 12.1982C9.50991 12.6785 8.86117 14.0722 9.36782 15.3111C9.87448 16.55 11.3447 17.165 12.6516 16.6847Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8812 16.6847C29.1881 16.2044 29.8369 14.8107 29.3302 13.5718C28.8235 12.3329 27.3533 11.7179 26.0464 12.1982C24.7395 12.6785 24.0908 14.0722 24.5974 15.3111C25.1041 16.55 26.5743 17.165 27.8812 16.6847Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.678 25.1193C27.678 25.5342 27.3223 25.8714 26.8846 25.8714H11.654C11.2163 25.8714 10.8606 25.5342 10.8606 25.1193C10.8606 24.7044 11.2163 24.3672 11.654 24.3672H26.8846C27.3223 24.3672 27.678 24.7044 27.678 25.1193Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSicon3);
export default __webpack_public_path__ + "static/media/sicon3.0a1d8d175d94424a468c9ee4696104f0.svg";
export { ForwardRef as ReactComponent };